import React from 'react';
import { connect } from "react-redux";
import createItem from '../../../../API/Provider/PostMeansOfPayment.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from '../../../../Global/loader'
import GetCountries from '../../../../API/Client/GetCountries'
import Select from 'react-select'
import { withNamespaces } from 'react-i18next';
import { Button, Row, Col, Form } from "react-bootstrap";

class CreateNaciniPlacanja extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        loading: false,
        description: "",
        allowed_invoice_types: "",
        fiscalization_label:  { value: 'G', label: 'G' },
        countries: [],
        country: null,
        fiscalize: true,
        send_receipt: true,

        fiscalization_label_list:[
            { value: 'G', label: 'G' },
            { value: 'K', label: 'K' },
            { value: 'T', label: 'T' },
            { value: 'C', label: 'C' },
            { value: 'O', label: 'O' }
        ]
    }

    componentDidMount = async () => {
        document.title = this.props.t("Means of payement") + "-" + this.props.t("Create")

         //get countries
         let items = await GetCountries()       
         let countryList = []
         
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })
             
        await this.setState({
             countries: countryList,
             country: countryList[0]
        })
 
        await this.setState({
             loading: false            
        })
    }

    handleChange(e){
        let value = e.target.value

        this.setState({
            [e.target.id]: value === 'on' ? !this.state[e.target.id] : value
        })
    }

    submitCreate = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()        

        let createPP = await createItem(
            this.state
        )

        if(createPP.data.status === 201){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: "Creating was successful",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('There was an error creating the client type, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }

    changeFiscalizationLabel(data){
        this.setState({
            fiscalization_label : data
        })
    }
   
    render(){  
        const { t } = this.props
        
        return (
            this.state.loading ?
                <Loader />
            :
            <Form className="form-container">
                <Row>        
                    <Col sm={12} xl={6} lg={6}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="country" column sm={2} md={4}>{t('Country')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Select
                                    options={this.state.countries} 
                                    onChange={(values) => this.handleCountryChange(values)}
                                    isClearable
                                    isInvalid={this.state.country === null}
                                    value={this.state.country}

                                />                                  
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="description" column sm={2} md={4}>{t('Description')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Form.Control        
                                    id="description"                          
                                    type="text"
                                    value={this.state.description}
                                    onChange={e => this.handleChange(e)}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="fiscalization_label" column sm={2} md={4}>{t('Fiscalization Label')}</Form.Label>
                            <Col sm={10} md={8}>
                                <Select
                                    options={this.state.fiscalization_label_list} 
                                    onChange={data => this.changeFiscalizationLabel(data)}
                                    isInvalid={this.state.fiscalization_label.length === 0}
                                    value={this.state.fiscalization_label}
                                />   
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label htmlFor="in_vat_system" column sm={2} md={4}>{t('Fisacalize')}</Form.Label>
                            <Col sm="10" md="8">
                                <Form.Label className="checbox-form-label" htmlFor="gridCheck2">
                                    <input    
                                        id="fiscalize"                       
                                        type="checkbox"
                                        checked={this.state.fiscalize}
                                        onChange={e => this.handleChange(e)}
                                    />
                                    
                                    &nbsp;&nbsp; {t('Fiscalize')}
                                </Form.Label>
                                <Form.Label className="checbox-form-label" htmlFor="gridCheck2">                                        
                                    <input    
                                        id="send_receipt"                       
                                        type="checkbox"
                                        checked={this.state.send_receipt}
                                        onChange={e => this.handleChange(e)}
                                    />
                                    
                                    &nbsp;&nbsp; {t('Create receipt')}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Col sm={12} className="text-center">
                                <Button                                     
                                    className="btnSpremi"                                     
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col> 
                        </Form.Group>                                 
                    </Col>
                </Row>           
                
                <Row className="back-button-container">
                    <Button 
                        variant='default'
                        className="btn-default mt-2 mb-2"
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                    </Button>
                </Row>
            </Form>
        )
    }
}
const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreateNaciniPlacanja));


